import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import Exchange from '../../models/Exchange';
import Subscription from '../../models/Subscription';
import User from '../../models/User';

import Loading from '../common/Loading';

import ButtonApproval from './ButtonApproval';
import ButtonFinalize from './ButtonFinalize';
import ButtonCancel from './ButtonCancel';
import ButtonInfos from './ButtonInfos';
import ButtonRating from './ButtonRating';
import ButtonsGuestpoints from './ButtonsGuestpoints';
import ExchangeTabs from './ExchangeTabs';
import ExchangeTotal from './ExchangeTotal';
import { ResolutionCenterButton } from './ResolutionCenterButton';
import { Flex } from '@homeexchange/design';

export class ExchangeDetails extends React.Component {
    static propTypes = {
        actions: PropTypes.shape({
            patchExchange: PropTypes.func.isRequired,
            approveConversation: PropTypes.func.isRequired,
            cancelConversation: PropTypes.func.isRequired,
            manageGuestpoints: PropTypes.func.isRequired
        }).isRequired,
        currency: PropTypes.string.isRequired,
        conversation: PropTypes.instanceOf(Conversation),
        subscription: PropTypes.instanceOf(Subscription),
        user: PropTypes.instanceOf(User).isRequired,
        finalizeExchange: PropTypes.func.isRequired,
        classNames: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.detailsRef = React.createRef();
    }

    componentDidMount() {
        document.dispatchEvent(new CustomEvent('exchange_details_mount'));
    }

    componentDidUpdate() {
        $(this.detailsRef.current).find('.btn-ajax.sending').removeClass('sending').attr('disabled', false);
    }

    shouldComponentUpdate(nextProps) {
        if (
            // nextProps.conversation.hasChanged(this.props.conversation)
            !_.isEqual(nextProps.conversation.toJSON(), this.props.conversation.toJSON()) ||
            !_.isEqual(nextProps.classNames, this.props.classNames)
        ) {
            return true;
        }
        return false;
    }

    canUnapprove() {
        const exchWithLowerStatus = this.props.conversation.getExchangeWithLowerStatus();
        return (
            !exchWithLowerStatus.get('update_status') &&
            exchWithLowerStatus.get('status') == Exchange.STATUS_PREAPPROVED
        );
    }

    canApprove() {
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        return exchangeAsHost && exchangeAsHost.get('status') == Exchange.STATUS_DEFAULT;
    }

    shouldDisplayResolutionCenterButton() {
        const { conversation } = this.props;
        const exchanges = conversation.get('exchanges');
        return exchanges.some(
            (exchange) => exchange.hasStartDatePassed() && exchange.get('can_declare_incident')
        );
    }

    render() {
        if (!this.props.conversation) {
            return (
                <div className={classNames('exchange-details', this.props.classNames)} ref={this.detailsRef}>
                    <Loading />
                </div>
            );
        }

        const exchange = this.props.conversation.getExchange();
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        const bothExchangesWasFinalized = this.props.conversation.isBothExchangeFinzalized();

        return (
            <div className={classNames('exchange-details', this.props.classNames)} ref={this.detailsRef}>
                <ExchangeTabs
                    conversation={this.props.conversation}
                    currency={this.props.currency}
                    user={this.props.user}
                    editable={
                        !exchange?.isFinalizedOrCanceled() &&
                        this.props.conversation.getExchangeWithLowerStatus().get('status') !=
                            Exchange.STATUS_ACCEPTED
                    }
                    patchExchange={this.props.actions.patchExchange}
                />

                <div className="form-group exchange-total">
                    <label htmlFor="total">{i18n.t('exchange:total')}</label>
                    <span className="value">
                        <ExchangeTotal
                            currency={this.props.currency}
                            conversation={this.props.conversation}
                            user={this.props.user}
                        />
                    </span>
                </div>

                <Flex direction="row" gap="2" className="exchange-details-buttons">
                    {this.shouldDisplayResolutionCenterButton() && (
                        <ResolutionCenterButton isFullWidth conversationId={this.props.conversation.id} />
                    )}

                    <ButtonInfos conversation={this.props.conversation} user={this.props.user} />

                    {this.canUnapprove() && (
                        <ButtonCancel conversation={this.props.conversation} user={this.props.user} />
                    )}

                    {this.canApprove() && (
                        <ButtonApproval
                            conversation={this.props.conversation}
                            subscription={this.props.subscription}
                            approveConversation={this.props.actions.approveConversation}
                            user={this.props.user}
                        />
                    )}

                    <ButtonFinalize
                        conversation={this.props.conversation}
                        subscription={this.props.subscription}
                        user={this.props.user}
                        finalizeExchange={this.props.finalizeExchange}
                    />

                    <ButtonRating
                        conversation={this.props.conversation}
                        color={
                            bothExchangesWasFinalized && exchangeAsHost?.hasToHandleGuestpoints()
                                ? 'tertiary'
                                : 'primary'
                        }
                    />

                    <ButtonsGuestpoints
                        conversation={this.props.conversation}
                        manageGuestpoints={this.props.actions.manageGuestpoints}
                    />
                </Flex>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        subscription: state.subscription ? state.subscription.subscription : null
    };
}

export default connect(mapStateToProps)(ExchangeDetails);
